export const CaseType = {
  DiggingPermit: 1,
  Leasehold: 2,
  TrafficArrangementPlan: 3
};
